import React from 'react'
import { useSelector } from 'react-redux'
import { scrollTo } from 'front-end-core/helpers/document'
import Hidden from '@material-ui/core/Hidden'
import { DASHBOARD } from 'constants/controllers'
import selectDeviceType from 'redux/selectors/selectDeviceType'
import logoBlackAbbrImg from 'images/fc-logo-abbr-black.svg'
import logoBlackImg from 'images/fc-logo-black.svg'
import selectAolName from 'redux/selectors/selectAolName'

const LogoLink = ({ className, pageId, activePage }) => {
  const activePageIsDashboard = activePage === DASHBOARD
  const { isMobile } = useSelector(selectDeviceType)
  const aol = useSelector(selectAolName)

  const handleLogoClick = () => {
    if (activePageIsDashboard) {
      scrollTo({ pageId, id: 0, animate: true, useWindowScrollTo: isMobile })
    }
  }

  return (
    <div {...{ className }} data-testid='logo-link'>
      <a
        href={aol}
        className='db'
        onClick={handleLogoClick}
        data-event-category='Logo'
        data-event-action='Select'
      >
        <Hidden smDown>
          <img className='db w13 h-100' src={logoBlackImg} alt='Logo' />
        </Hidden>
        <Hidden mdUp>
          <img className='db w9 header-icon-mobile-width h-100' src={logoBlackAbbrImg} alt='Logo' />
        </Hidden>
      </a>
    </div>
  )
}

export default LogoLink
